import { useIntl } from "react-intl";
import { ErrorsType } from "..";
import { Custom } from "./Custom";

interface Props {
    tasOccurrenceNumber?: string;
    isLoading: boolean;
    subject?: string;
    customerComment: string;
    handleChangeComment: (comment: string) => void;
    diagnose: string;
    handleDiagnose: (diagnose: string) => void;
    repair: string;
    handleRepair: (repair: string) => void;
    analysisReason: string;
    handleAnalysisReason: (repair: string) => void;
    partName: string;
    handlePartName: (partName: string) => void;
    aeg: string;
    handleAeg: (aeg: string) => void;
    errors: ErrorsType;
    cancelComment: string
    handleCancelComment: (aeg: string) => void;
    vehicleQtd: string;
    handleVehicleQtd: (aeg: string) => void;
    cancelReason: string;
    handleCancelReason: (cancel: string) => void;
}

const AdditionalData = ({
    tasOccurrenceNumber,
    isLoading,
    customerComment,
    handleChangeComment,
    subject,
    diagnose,
    handleDiagnose,
    repair,
    handleRepair,
    analysisReason,
    handleAnalysisReason,
    partName,
    handlePartName,
    aeg,
    handleAeg,
    errors,
    cancelComment,
    handleCancelComment,
    handleVehicleQtd,
    vehicleQtd,
    cancelReason,
    handleCancelReason
}: Props) => {
    const intl = useIntl();
    const requiredLabel = (id: string, required = true) => `${intl.formatMessage({ id })}${required ? '*' : ''}`;
    const requiredPlaceholder = intl.formatMessage({ id: "intl-msg:occurrence.required" });
    const optionalPlaceholder = intl.formatMessage({ id: "intl-msg:occurrence.optional" });

    const onlyNumbers = (value: string) => {
        return value.replace(/\D/g, '');
    };

    return (
        <div className="width-100pct height-100pct border rounded padding-15">
            <div className="margin-bottom-15">
                <span className="text-size-14 text-medium text-color-black">{intl.formatMessage({ id: "intl-msg:support.administrative.additionalDataTitle" })}</span>
            </div>
            <div className="width-100pct display-flex flex-row gap-20">
                {subject === 'CONTRACT_CANCELLATION'? (
                    <Custom.Input label={requiredLabel("intl-msg:support.constants.field.contractNumber")} value={tasOccurrenceNumber} disabled={true} isLoading={isLoading} />
                ) : null}

                {subject === "CONTRACT_CANCELLATION" ? (
                    <>
                        <Custom.Input
                            label={requiredLabel("intl-msg:support.constants.field.vehicleQtd")}
                            value={vehicleQtd}
                            isLoading={isLoading}
                            onChange={handleVehicleQtd}
                            // error={errors.vehicleQtd}
                            placeholder={requiredPlaceholder}
                            disabled
                        />

                        <Custom.Input
                            label={requiredLabel("intl-msg:support.constants.field.cancelReason")}
                            value={cancelReason}
                            isLoading={isLoading}
                            onChange={handleCancelReason}
                            // error={errors.cancelReason}
                            placeholder={requiredPlaceholder}
                            disabled
                        />
                    </>
                ) : null}

                {subject === "TECHNICAL" ? (
                    <>
                        <Custom.Input
                            label={requiredLabel("intl-msg:support.constants.field.partName")}
                            value={partName}
                            isLoading={isLoading}
                            onChange={handlePartName}
                            // error={errors.partName}
                            placeholder={requiredPlaceholder}
                            disabled
                        />
                        <Custom.Input
                            label={intl.formatMessage({ id: "intl-msg:support.constants.field.aeg" })}
                            value={aeg}
                            isLoading={isLoading}
                            onChange={(e) => handleAeg(onlyNumbers(e))}
                            // error={errors.aeg}
                            placeholder={optionalPlaceholder}
                            // disabled
                        />
                    </>
                ) : null}
            </div>


            {subject === 'CONTRACT_CANCELLATION' ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={requiredLabel("intl-msg:support.constants.field.cancelComment")}
                        value={cancelComment} 
                        onChange={handleCancelComment}
                        isLoading={isLoading}
                        // error={errors.cancelComment}
                        placeholder={requiredPlaceholder}
                        disabled
                    />
                </div>
            ) : (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={subject === "TECHNICAL" ? requiredLabel("intl-msg:support.tasAdditionalRequiredFields.customerComplaint") : intl.formatMessage({ id: "intl-msg:support.administrative.requestDetail" })}
                        value={customerComment} 
                        onChange={handleChangeComment}
                        isLoading={isLoading}
                        // error={errors.customerComment}
                        placeholder={subject === "TECHNICAL" ? requiredPlaceholder : optionalPlaceholder}
                        disabled
                    />
                </div>
            )}

            {subject === "TECHNICAL" ? (
                <div className="width-100pct">
                    <Custom.TextArea
                        label={requiredLabel("intl-msg:support.constants.field.diagnose")}
                        value={diagnose}
                        onChange={handleDiagnose}
                        isLoading={isLoading}
                        // error={errors.diagnose}
                        placeholder={requiredPlaceholder}
                        disabled
                    />
                    <Custom.TextArea
                        label={requiredLabel("intl-msg:support.constants.field.repair")}
                        value={repair}
                        onChange={handleRepair}
                        isLoading={isLoading}
                        // error={errors.repair}
                        placeholder={requiredPlaceholder}
                        disabled
                    />
                    <Custom.TextArea
                        label={requiredLabel("intl-msg:support.constants.field.analysisReason")}
                        value={analysisReason}
                        onChange={handleAnalysisReason}
                        isLoading={isLoading}
                        // error={errors.analysisReason}
                        placeholder={requiredPlaceholder}
                        disabled
                    />
                </div>
            ) : null}
        </div>
    )
}

export default AdditionalData;